
import { Component, Vue, Prop } from 'vue-property-decorator';
import { IFilterGroup } from '@/contract/search.contract';

@Component({})
export default class FacetSearchBase extends Vue {
  @Prop()
  protected filters!: IFilterGroup[];

  private filterOrder = [
    "objectType",
    "talenToepasselijk",
    "bouwwerkTypes",
    "bouwwerkDelen",
    "materiaalType",
    "specifiekMateriaalType",
    "typeSysteem",
    "subtypeSysteem",
    "productGroep",
    "gecertificeerdProductType",
    "specifiekProductType",
    "componentVoorToepassingInSystemen",
    "grondstofVoorProduct",
    "componentVanSysteem",
    "halffabrikaatVanProduct",
    "processen",
    "specifiekeProcessen",
    "diensten",
    "specifiekeDiensten",
    "merknaam",
    "codeBinnenSysteem",
    "schemaCode",
    "toepasselijkePTV",
    "toepasselijkeTRA",
    "toepasselijkeSchemaDocument",
    "toepasselijkeBestekken",
    "certificaatHouder",
    "productieZetels",
    "distributieZetels",
    "verwerkers",
    "uitvoerders",
    "bedrijf",
    "commercieleNaam",
    "snelcode",
    "alternatieveCode",
    "toepassingsEigenschappen"]

  public get sortedFilters(): IFilterGroup[] {
    // To sort alphabetically
    // return [...this.filters].sort((f1, f2) => (f2.collapsed ? 1 : f1.collapsed ? -1 : f2.id > f1.id ? 1 : -1));
    // Sort on the order defined in filterOrder
    return [...this.filters].sort((f1, f2) => (
      this.indexInOrderedList(f1) < this.indexInOrderedList(f2) ? -1 : 1)
      );
  }

  protected indexInOrderedList(filterGroup: IFilterGroup): number {
    const filterPrefix = filterGroup.id.split(".")[0]
    
    if (!this.filterOrder.includes(filterPrefix)){
      return Number.MAX_SAFE_INTEGER
    }
    return this.filterOrder.indexOf(filterPrefix)    
  }

  protected onFilterTermChanged(filterGroup: string, filterTerm: string) {
    this.$emit('filter-term-changed', filterGroup, filterTerm);
  }
}
